/** Dates in the league's local time, including the late-evening UTC boundary. */
internal fun leagueDateIso(timestamp: Double = kotlin.js.Date.now()): String =
    kotlin.js.Date(timestamp).asDynamic().toLocaleDateString("sv-SE",
        js("({timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit'})")) as String

internal data class TeamSchedule(val next: TeamMatchDto?, val overdue: List<TeamMatchDto>)

private fun TeamMatchDto.windowStart(): String? = roundDateFrom ?: date?.take(10)
private fun TeamMatchDto.windowEnd(): String? = roundDateTo ?: windowStart()

internal fun teamSchedule(matches: List<TeamMatchDto>, today: String): TeamSchedule {
    val pending = matches.filter { it.status == "scheduled" }
    val ongoing = pending.filter { m ->
        val from = m.windowStart(); val to = m.windowEnd()
        from != null && to != null && from <= today && today <= to
    }.sortedWith(compareBy<TeamMatchDto> { it.windowEnd() }.thenBy { it.windowStart() }.thenBy { it.roundNumber })
    val future = pending.filter { it.windowStart()?.let { from -> from > today } == true }
        .sortedWith(compareBy<TeamMatchDto> { it.windowStart() }.thenBy { it.roundNumber })
    val overdue = pending.filter { it.windowEnd()?.let { to -> to < today } == true }
        .sortedWith(compareBy<TeamMatchDto> { it.windowEnd() }.thenBy { it.roundNumber })
    val undated = pending.filter { it.windowStart() == null && it.windowEnd() == null }
        .sortedBy { it.roundNumber }
    return TeamSchedule(ongoing.firstOrNull() ?: future.firstOrNull() ?: undated.firstOrNull(), overdue)
}

private fun czechDate(iso: String, year: Boolean = true): String {
    val parts = iso.take(10).split("-")
    val day = parts.getOrNull(2)?.toIntOrNull() ?: return iso
    val month = parts.getOrNull(1)?.toIntOrNull() ?: return iso
    return "$day. $month.${if (year) " ${parts[0]}" else ""}"
}

internal fun matchWindowLabel(match: TeamMatchDto): String {
    val from = match.windowStart() ?: return "Termín neurčen"
    val to = match.windowEnd() ?: from
    if (from == to) return czechDate(from)
    return "${czechDate(from, from.take(4) != to.take(4))} – ${czechDate(to)}"
}
